import type React from "react";
import { Outlet } from "react-router-dom";

const AdminLayout: React.FC = () => {
	return (
		<div className="p-6">
			<Outlet />
		</div>
	);
};

export default AdminLayout;
